<template>
  <v-container
    fluid
    fill-height
    class="grey lighten-4"
  >
    <v-layout
      align-center
      justify-center
    >
      <v-flex
        xs12
        sm8
        md4
        class="text-xs-center"
      >
        <!-- <img src="static/logo.png" width="180"  /> -->
        <h1>Global Rescue</h1>
        <h3>כניסה למערכת</h3>

        <v-card
          flat
          color="transparent"
        >
          <v-card-text>
            <div class="firebaseui-auth-outer-container">
              <div id="firebaseui-auth-container"></div>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import firebase from "firebase/app";
import firebaseAuth from "firebase/auth";

export default {
  name: "auth",
  data() {
    return {};
  },
  computed: {
    user() {
      return this.$store.getters["user/user"];
    },
    isShown() {
      return true;
    }
  },
  methods: {},
  components: {},
  created() {},
  mounted() {
    let self = this;
    let firebaseui = require("firebaseui");
    // let firebaseui__iw = require("firebaseui/dist/firebaseui__iw.js");
    let uiConfig = {
      signInFlow: "popup",
      signInOptions: [
        {
          provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          scopes: ["profile", "email"]
        },
        {
          provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
          defaultCountry: "IL",
          recaptchaParameters: {
            type: "image", // 'audio'
            size: "invisible", // 'invisible' or 'compact'
            badge: "bottomleft" //' bottomright' or 'inline' applies to invisible.
          },
          scopes: []
        }
      ],
      callbacks: {
        signInSuccessWithAuthResult: (authResult, redirectUrl) => {
          let user = authResult.user;
          let isNewUser = authResult.additionalUserInfo.isNewUser;
          return false;
        }
      }
    };
    let ui = firebaseui.auth.AuthUI.getInstance();
    if (!ui) {
      ui = new firebaseui.auth.AuthUI(firebase.auth());
    }

    ui.start("#firebaseui-auth-container", uiConfig);
  }
};
</script>

<style scoped lang="scss">
// @import "../utils/firebaseui-he/dist/firebaseui-rtl.css";
@import "~firebaseui/dist/firebaseui.css";
</style>


// WEBPACK FOOTER //
// src/components/Auth.vue